// needed for vite
import '../css/main.scss';

document.addEventListener( 'DOMContentLoaded', function() {

  ( function(menuClass, wrapperClass, togglerClass ) {

    function toggleState(togglerClass, wrapperClass) {
      console.log(togglerClass, wrapperClass)
      console.log('next');
      let siteNavigationWrapper = document.querySelector( '.' + wrapperClass );
      let togglerButton = siteNavigationWrapper.parentNode.querySelector( '.' + togglerClass );
			togglerButton.classList.toggle( togglerClass + '--toggled' );
			siteNavigationWrapper.classList.toggle( wrapperClass + '--toggled' );
			// track document state
			document.body.classList.toggle('menu--toggled');
	
			if ( togglerButton.getAttribute( 'aria-expanded' ) === 'true' ) {
				togglerButton.setAttribute( 'aria-expanded', 'false' );
			} else {
				togglerButton.setAttribute( 'aria-expanded', 'true' );
			}
		}
		/**
		 * Sets or removes .focus class on an element.
		 */
		function toggleFocus() {
			if ( event.type === 'focus' || event.type === 'blur' ) {
				let self = this;
				// Move up through the ancestors of the current link until we hit .h-menu.
				while ( ! self.classList.contains( menuClass ) ) {
					// On li elements toggle the class .focus.
					if ( 'li' === self.tagName.toLowerCase() ) {
						self.classList.toggle( 'focus' );
					}
					self = self.parentNode;
				}
			}
	
			if ( event.type === 'touchstart' ) {
				let menuItem = this.parentNode;
				event.preventDefault();
				for ( let link of menuItem.parentNode.children ) {
					if ( menuItem !== link ) {
						link.classList.remove( 'focus' );
					}
				}
				menuItem.classList.toggle( 'focus' );
			}
		}

		let siteNavigationWrapper = document.querySelector( '.' + wrapperClass );
    // console.log(siteNavigationWrapper); // DEBUG: console log

    // Return early if the navigation doesn't exist.
		if ( ! siteNavigationWrapper ) {
			return;
		}
	
		let togglerButton = siteNavigationWrapper.parentNode.querySelector( '.' + togglerClass );
    // console.log(togglerButton); // DEBUG: console log
	
		// Return early if the button doesn't exist.
		if ( 'undefined' === typeof togglerButton ) {
			return;
		}
	
		let menu = siteNavigationWrapper.getElementsByTagName( 'ul' )[ 0 ];
    // console.log(menu); // DEBUG: console log
	
		// Hide menu toggle button if menu is empty and return early.
		if ( 'undefined' === typeof menu ) {
			togglerButton.style.display = 'none';
			return;
		}
	
		if ( !menu.classList.contains( menuClass ) ) menu.classList.add( menuClass );
	
		// Toggle the .nav-area--toggled class and the aria-expanded value each time the button is clicked.
		togglerButton.addEventListener( 'click', function() {
			toggleState(togglerClass, wrapperClass);
		} );
	
		// Remove the .nav-area--toggled class and set aria-expanded to false when the user clicks outside the navigation.
		// document.body.addEventListener( 'click', function( event ) {
		// 	let isClickInside = siteNavigationWrapper.contains( event.target );
	
		// 	if ( ! isClickInside ) {
		// 		console.log(siteNavigationWrapper, siteNavigationWrapper.classList)
		// 		siteNavigationWrapper.classList.remove( wrapperClass + '--toggled' );
		// 		togglerButton.setAttribute( 'aria-expanded', 'false' );
		// 	}
		// } );
	
		// Get all the link elements within the menu.
		let links = menu.getElementsByTagName( 'a' );
	
		// Get all the link elements with children within the menu.
		let linksWithChildren = menu.querySelectorAll( menuClass + '__item--parent' );
	
		// Toggle focus each time a menu link is focused or blurred.
		for ( let link of links ) {
			link.addEventListener( 'focus', toggleFocus, true );
			link.addEventListener( 'blur', toggleFocus, true );
			
			if (link.hash) {

				link.addEventListener( 'click', function(){
					if (document.body.classList.contains('menu--toggled'))
						toggleState(togglerClass, wrapperClass);
				}, true );
			}
		}
	
		// Toggle focus each time a menu link with children receive a touch event.
		for ( let link of linksWithChildren ) {
			link.addEventListener( 'touchstart', toggleFocus, false );
		}
	
	}('h-menu', 'nav-area', 'nav-toggler') );

     /* js accordion */
    let accordionClass = '.accordion';
    let accordionItemClass = accordionClass + '__item';
    let accordionItemTitleClass = accordionItemClass + '-title';
    let accordionItemActiveClass = accordionItemClass + '--active';
    
    const accordions = document.querySelectorAll(accordionClass);
    if ( accordions ) {
      accordions.forEach(function(accordion) {
        let itemTitle = accordion.querySelectorAll(accordionItemTitleClass);
        itemTitle.forEach(function(item) {
          item.addEventListener('click',function(event){
            let parent = event.target.closest(accordionItemClass);

             // roll-up all before set new active
              event.target.closest(accordionClass).querySelectorAll(accordionItemClass).forEach(function(childItem){
                if (parent && !parent.isEqualNode(childItem)) {
                  childItem.classList.remove(accordionItemActiveClass.replace(/\./g, ''));
                }
              });

            parent.classList.toggle(accordionItemActiveClass.replace(/\./g, ''));

          });
        });
      });
    }

    /* js tabs */
    let tabsClass = 'tabs';
    let tabsNavItemClass = tabsClass + '__nav-item';
    let tabsNavItemActiveClass = tabsNavItemClass + '--active';
    let tabsNavPaneClass = tabsClass + '__pane';
    let tabsNavPaneActiveClass = tabsNavPaneClass + '--active';

    const navTabs = document.querySelectorAll('.' + tabsClass);
    if ( navTabs) {
      navTabs.forEach(function(navTab){
        const navTabsItems = navTab.querySelectorAll('.' + tabsNavItemClass);

        function navTabActivate(event) {
          for (var i = 0; i < navTabsItems.length; i++) {
              navTabsItems[i].classList.remove(tabsNavItemActiveClass);
          }
          var clickedTab = event.currentTarget;
          clickedTab.classList.add(tabsNavItemActiveClass);
          event.preventDefault();
  
          var tabContentPanes = navTab.querySelectorAll('.' + tabsNavPaneClass);
          for (i = 0; i < tabContentPanes.length; i++) {
              tabContentPanes[i].classList.remove(tabsNavPaneActiveClass);
          }
  
          var anchorReference = event.target;
          var tabContentPaneId = anchorReference.getAttribute("href");
          var tabContentPane = navTab.querySelector(tabContentPaneId);
          tabContentPane.classList.add(tabsNavPaneActiveClass);
        }
        
        if ( navTabsItems ) {
          for (i = 0; i < navTabsItems.length; i++) {
              navTabsItems[i].addEventListener("click", navTabActivate)
          }
        }
      })
    }


    /* Clien cases slider */
    if (document.querySelector('.js-cases__slider.splide')) {
        let offerPageSplider = new Splide( '.js-cases__slider.splide', {
          rewind : true,
          type   : 'slider',
          autoplay : true,
          perPage: 1,
          perMove: 1,
          focus  : 0,
          center: true,
          trimSpace: true,
          speed  : 500,
          gap    : '24px',
          updateOnMove: true,
          pagination: true
        } );
  
        offerPageSplider.mount();
    }

    /* Reviews slider */
    if (document.querySelector('.js-reviews__slider.splide')) {
        let offerPageSplider = new Splide( '.js-reviews__slider.splide', {
          rewind : true,
          type   : 'loop',
          autoplay : true,
          perPage: 3,
          perMove: 3,
          focus  : 0,
          center: true,
          trimSpace: true,
          speed  : 500,
          gap    : '20px',
          updateOnMove: true,
          pagination: true,
          breakpoints: {
            992: {
              center: false,
              perPage: 2,
            },
            768: {
              center: false,
              perPage: 1,
              perMove: 1,
            }
          }
        } );
  
        offerPageSplider.mount();
    }



    /* range input in how much block */
    let rangeInput = document.querySelector(".how-much-range__input input");
    if (rangeInput instanceof HTMLElement) {
      updateRangeInput()
      rangeInput.addEventListener("input", function (e) {
        updateRangeInput();
      });
    }

    let rangeInputIncBtn = document.querySelector(".how-much-range__value--inc");
    if (rangeInputIncBtn instanceof HTMLElement) {
      rangeInputIncBtn.addEventListener('click', function(){
        rangeInput.stepUp(1);
        updateRangeInput();
      });
    }
    let rangeInputDecBtn = document.querySelector(".how-much-range__value--dec");
    if (rangeInputDecBtn instanceof HTMLElement) {
      rangeInputDecBtn.addEventListener('click', function(){
        rangeInput.stepDown(1);
        updateRangeInput();
      })
    }
    


    function updateRangeInput() {

      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
      });

      if (rangeInput instanceof HTMLElement) {
        let rangeValue = rangeInput.value / 3000000;
        let rangeInputWidth = rangeInput.offsetWidth;

        let rangeValueElement = document.querySelector(".how-much-range__value");
        let rangeValueCostElement = document.querySelector(".how-much-range__efficiency-value");
        let rangeInputHighligted = document.querySelector(".how-much-range__highlighter");
        rangeInputHighligted.style.width = rangeInputWidth * rangeValue + "px";
        rangeValueElement.innerHTML = formatter.format(rangeInput.value);
        rangeValueCostElement.innerHTML = formatter.format(rangeInput.value * 0.03) + '/yr.';
      }


    }
    window.addEventListener('resize', function(event) {
      updateRangeInput()
    }, true);


});